import React from 'react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAudioDescription = props => /*#__PURE__*/_jsx("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  ...props,
  children: /*#__PURE__*/_jsxs("g", {
    fill: "none",
    fillRule: "evenodd",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M0 0h24v24H0z"
    }), /*#__PURE__*/_jsx("path", {
      fill: "currentColor",
      d: "M16.362 9.844v5.509c.04.003.071.012.099.007.101-.02.203-.039.303-.065.74-.2 1.407-.524 1.92-1.116.774-.89.8-2.071.075-2.999-.419-.534-.966-.874-1.59-1.102-.253-.093-.519-.151-.807-.234m-2.7 8.366V7.042c.64 0 1.268-.015 1.894.006.381.013.763.066 1.14.13.756.13 1.48.36 2.168.705.64.322 1.212.729 1.705 1.247a5.119 5.119 0 011.229 2.13c.25.863.269 1.733.05 2.594-.299 1.175-.96 2.123-1.926 2.862-.758.58-1.609.957-2.524 1.2a9.204 9.204 0 01-2.222.292c-.498.009-.997.002-1.514.002m-3.447-4.03v-3.19l-.037-.014-2.24 3.205h2.277zM2 17.913c.183-.245.374-.485.55-.736.826-1.178 1.648-2.36 2.472-3.54l2.173-3.11A958.17 958.17 0 019.56 7.155c.03-.042.091-.086.138-.086 1.06-.003 2.121 0 3.182.001.01 0 .022.008.056.022v.185c0 3.56-.001 7.119.004 10.678 0 .175-.045.229-.223.227-.756-.01-1.512-.01-2.268 0-.18.002-.23-.056-.222-.23.012-.303 0-.608.005-.912.002-.11-.036-.148-.148-.148-1.31.003-2.621 0-3.932.007-.064 0-.15.053-.189.107-.244.34-.473.688-.718 1.027-.046.065-.138.138-.21.138-1.012.006-2.023 0-3.035-.003v-.256z"
    })]
  })
});
export default SvgAudioDescription;